import { Box, Typography, useTheme } from '@mui/material';
import type { PasswordScore, PasswordStrength } from '~/lib/password';

interface StrengthBarProps {
  barNum: number;
  score: PasswordScore;
}

export const StrengthBar = ({ barNum, score }: StrengthBarProps) => {
  const theme = useTheme();

  const barColors = [
    theme.palette.error.main,
    theme.palette.warning.main,
    theme.palette.warning.main,
    theme.palette.success.main,
    theme.palette.success.dark,
  ];

  return (
    <Box
      display="flex"
      flexBasis="0"
      flexGrow="1"
      width="100%"
      maxWidth="100%"
      height="8px"
      borderRadius="20px"
      sx={{
        backgroundColor: score >= barNum ? barColors[score] : 'borders.light',
      }}
    ></Box>
  );
};

export const PasswordStrengthMeter = ({ strength }: { strength: PasswordStrength | undefined }) => {
  if (!strength) return null;
  const { feedback, score } = strength;
  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="row" gap="4px">
        <StrengthBar barNum={0} score={score} />
        <StrengthBar barNum={1} score={score} />
        <StrengthBar barNum={2} score={score} />
        <StrengthBar barNum={3} score={score} />
        <StrengthBar barNum={4} score={score} />
      </Box>
      <Typography
        component="p"
        variant="caption"
        margin="5px 0 0"
        color="text.secondary"
        textAlign="right"
      >
        {feedback}
      </Typography>
    </Box>
  );
};
